var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 113,
    viewBox: "0 0 152 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.17 0H32.8081C28.6954 0 25.3613 3.51776 25.3613 7.85714V102.143C25.3613 106.482 28.6954 110 32.8081 110H122.17C126.283 110 129.617 106.482 129.617 102.143V7.85714C129.617 3.51776 126.283 0 122.17 0Z",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3565_263441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7449 42.4258H142.277C143.264 42.4258 144.211 42.8397 144.91 43.5764C145.608 44.3132 146 45.3124 146 46.3544V65.9972C146 67.0391 145.608 68.0384 144.91 68.7751C144.211 69.5119 143.264 69.9258 142.277 69.9258H41.7449C40.7574 69.9258 39.8103 69.5119 39.112 68.7751C38.4138 68.0384 38.0215 67.0391 38.0215 65.9972V46.3544C38.0215 45.3124 38.4138 44.3132 39.112 43.5764C39.8103 42.8397 40.7574 42.4258 41.7449 42.4258Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8516 48.7129H77.4899C76.2561 48.7129 75.2559 49.7682 75.2559 51.07C75.2559 52.3718 76.2561 53.4272 77.4899 53.4272H96.8516C98.0854 53.4272 99.0856 52.3718 99.0856 51.07C99.0856 49.7682 98.0854 48.7129 96.8516 48.7129Z",
    fill: "#C6CFD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.256 58.9258H77.4899C76.2561 58.9258 75.2559 59.9811 75.2559 61.2829C75.2559 62.5847 76.2561 63.6401 77.4899 63.6401H110.256C111.49 63.6401 112.49 62.5847 112.49 61.2829C112.49 59.9811 111.49 58.9258 110.256 58.9258Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7346 63.6454C64.6417 63.6454 67.8091 60.3035 67.8091 56.1811C67.8091 52.0587 64.6417 48.7168 60.7346 48.7168C56.8275 48.7168 53.6602 52.0587 53.6602 56.1811C53.6602 60.3035 56.8275 63.6454 60.7346 63.6454Z",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3565_263441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7234 76.2188H110.255C111.243 76.2188 112.19 76.6327 112.888 77.3694C113.586 78.1062 113.979 79.1054 113.979 80.1473V99.7902C113.979 100.832 113.586 101.831 112.888 102.568C112.19 103.305 111.243 103.719 110.255 103.719H9.7234C8.7359 103.719 7.78883 103.305 7.09056 102.568C6.39229 101.831 6 100.832 6 99.7902V80.1473C6 79.1054 6.39229 78.1062 7.09056 77.3694C7.78883 76.6327 8.7359 76.2188 9.7234 76.2188V76.2188Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8291 82.502H45.4674C44.2336 82.502 43.2334 83.5573 43.2334 84.8591C43.2334 86.1609 44.2336 87.2162 45.4674 87.2162H64.8291C66.063 87.2162 67.0632 86.1609 67.0632 84.8591C67.0632 83.5573 66.063 82.502 64.8291 82.502Z",
    fill: "#C6CFD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2334 92.7148H45.4674C44.2336 92.7148 43.2334 93.7702 43.2334 95.072C43.2334 96.3738 44.2336 97.4291 45.4674 97.4291H78.2334C79.4672 97.4291 80.4674 96.3738 80.4674 95.072C80.4674 93.7702 79.4672 92.7148 78.2334 92.7148Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0335 97.4305C22.9406 97.4305 26.1079 94.0886 26.1079 89.9662C26.1079 85.8438 22.9406 82.502 19.0335 82.502C15.1263 82.502 11.959 85.8438 11.959 89.9662C11.959 94.0886 15.1263 97.4305 19.0335 97.4305Z",
    fill: "#D9D9D9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3565_263441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.255 8.64453H9.7234C7.66702 8.64453 6 10.4034 6 12.5731V32.216C6 34.3856 7.66702 36.1445 9.7234 36.1445H110.255C112.312 36.1445 113.979 34.3856 113.979 32.216V12.5731C113.979 10.4034 112.312 8.64453 110.255 8.64453Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3399 14.9277H43.9782C42.7444 14.9277 41.7441 15.9831 41.7441 17.2849C41.7441 18.5867 42.7444 19.642 43.9782 19.642H63.3399C64.5737 19.642 65.5739 18.5867 65.5739 17.2849C65.5739 15.9831 64.5737 14.9277 63.3399 14.9277Z",
    fill: "#C6CFD2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7441 25.1406H43.9782C42.7444 25.1406 41.7441 26.196 41.7441 27.4978C41.7441 28.7996 42.7444 29.8549 43.9782 29.8549H76.7441C77.978 29.8549 78.9782 28.7996 78.9782 27.4978C78.9782 26.196 77.978 25.1406 76.7441 25.1406Z",
    fill: "#F7F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7122 29.8563C32.6193 29.8563 35.7866 26.5144 35.7866 22.392C35.7866 18.2696 32.6193 14.9277 28.7122 14.9277C24.805 14.9277 21.6377 18.2696 21.6377 22.392C21.6377 26.5144 24.805 29.8563 28.7122 29.8563Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3565_263441",
    x: 32.0215,
    y: 39.4258,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3565_263441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3565_263441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3565_263441",
    x: 0,
    y: 73.2188,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3565_263441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3565_263441",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3565_263441",
    x: 0,
    y: 5.64453,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3565_263441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3565_263441",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.d51c13a4b739e5f61de561de809bc1e7.svg";
export { ForwardRef as ReactComponent };